import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { opacity: "0.7" }, [
      _createElementVNode("path", {
        d: "M10.1712 15.5385L16.501 10L10.1712 4.46154",
        stroke: "white",
        "stroke-width": "1.6",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      _createElementVNode("path", {
        d: "M4.50125 15.5385L10.8311 10L4.50125 4.46154",
        stroke: "white",
        "stroke-width": "1.6",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ]))]))
}
export default { render: render }